import styled, { css } from 'styled-components';
import { shade } from 'polished';

interface FormProps {
  hasError: boolean;
}

export const Title = styled.h1`
  color: #3a3a3a;
  font-size: 48px;
  margin-top: 80px;
  max-width: 450px;
  line-height: 56px;
`;

export const Form = styled.form<FormProps>`
  margin-top: 40px;
  max-width: 700px;

  display: flex;

  input {
    flex: 1;
    height: 70px;
    padding: 0 24px;
    border: 0;
    border-radius: 5px 0 0 5px;
    color: #3a3a3a;
    border: 2px solid #fff;
    border-right: 0;
    transition: border-color 0.2s;

    ${(props) =>
      props.hasError &&
      css`
        border-color: #c53030;
      `}

    &::placeholder {
      color: #a8a8b3;
    }
  }

  button {
    width: 210px;
    height: 70px;
    background-color: #04d361;
    border-radius: 0 5px 5px 0;
    color: #fff;
    border: 0;
    font-weight: bold;
    transition: background-color 0.2s;

    &:hover {
      background-color: ${shade(0.2, '#04d361')};
    }
  }
`;

export const Error = styled.span`
  display: block;
  color: #c53030;
  margin-top: 8px;
`;

export const Repositories = styled.div`
  margin-top: 80px;
  max-width: 700px;

  div {
    position: relative;
    & + div {
      margin-top: 16px;
    }

    &:hover {
      a {
        transform: translateX(85px);
      }

      button {
        visibility: visible;
      }
    }

    button {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      border: 0;
      border-radius: 5px 0 0 5px;
      background-color: #c53030;
      color: #fff;
      padding: 0 16px;
      visibility: hidden;
      transition: visibility 0.5s ease-in-out;
    }

    a {
      z-index: 1;
      background-color: #fff;
      border-radius: 5px;
      width: 100%;
      padding: 24px;
      text-decoration: none;

      display: flex;
      align-items: center;
      transition: transform 0.5s;

      img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
      }

      div {
        margin: 0 16px;
        flex: 1;

        strong {
          font-size: 20px;
          color: #3d3d4d;
        }

        p {
          font-size: 18px;
          color: #a8a8b3;
          margin-top: 4px;
        }
      }

      svg {
        margin-left: auto;
        color: #cbcbd6;
      }
    }
  }
`;
